import { render, staticRenderFns } from "./Week.vue?vue&type=template&id=2f66d49a&scoped=true"
import script from "./Week.vue?vue&type=script&lang=js"
export * from "./Week.vue?vue&type=script&lang=js"
import style0 from "./Week.vue?vue&type=style&index=0&id=2f66d49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66d49a",
  null
  
)

export default component.exports